/**
 * @desc remove string query params that may contain sensitive information
 */
const redactQueryString = (url: string, replaceValue = `?REDACTED=true`) =>
  url.replace(/(?:.(?!\?))+$/, replaceValue);

export default redactQueryString;
